var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYtIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.197,
    height: 30.197,
    viewBox: "0 0 30.197 30.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-824.391 -10703.829)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(824.391 10703.829)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.099,
    cy: 15.099,
    r: 15.099,
    transform: "translate(0 0)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.807,17.58a.232.232,0,0,0-.063-.19v-.063a1.364,1.364,0,0,0-1.327-.948h.127A42.358,42.358,0,0,0,19.73,16a43.535,43.535,0,0,0-5.813.379h.127a1.364,1.364,0,0,0-1.327.948v.063a.232.232,0,0,1-.063.19,30.712,30.712,0,0,0-.253,3.476,30.711,30.711,0,0,0,.252,3.476.232.232,0,0,0,.063.19v.063a1.364,1.364,0,0,0,1.327.948h-.127a42.358,42.358,0,0,0,5.813.379,43.536,43.536,0,0,0,5.813-.379h-.127a1.364,1.364,0,0,0,1.327-.948v-.063a.232.232,0,0,1,.063-.19,30.712,30.712,0,0,0,.252-3.476,20.565,20.565,0,0,0-.251-3.476Zm-4.929,3.791-2.97,2.149a.316.316,0,0,1-.379,0,.348.348,0,0,1-.187-.312v-4.3a.348.348,0,0,1,.19-.316.4.4,0,0,1,.379,0l2.97,2.149a.487.487,0,0,1,.127.316.231.231,0,0,1-.13.316Z",
    transform: "translate(-4.564 -5.791)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/yt-icon.6b39a3a48c39cfe7921dc3e195f9a98c.svg";
export { ForwardRef as ReactComponent };